import * as React from 'react';
import { useState, useCallback } from 'react';
import { Languages, Constants } from '../../common';
import { useStripe } from '@stripe/react-stripe-js';

import { styled } from '@mui/material/styles';
import { Dialog, DialogActions, DialogContent, DialogContentText, Button, DialogTitle, Slide } from '@mui/material';
import { actions } from '../../redux/UserRedux';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getApiHeader } from '../../utils/CommonFunctions';
import { UserAPI } from '../../services';
// import DeleteIcon from '@mui/icons-material/Delete';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {/* {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null} */}
        </DialogTitle>
    );
}

const PlanItem = ({ showMsg, planData, onContinue }) => {

    const stripe = useStripe();
    const history = useHistory();
    const dispatch = useDispatch();

    const pageType = sessionStorage.getItem('type');

    const [openModal, setOpenModal] = useState(false);
    const [open, setOpen] = useState(false);
    const alertMsg = useSelector((state) => state.user.alertMsg);
    const activation_id = useSelector((state) => state.user.activationId);

    const alertPage = useSelector((state) => state.user.alertPage);

    const openCloseAlert = useCallback((isShowAlert, msg, page) => {
        dispatch(actions.openCloseAlert(isShowAlert, msg, page));
    }, [dispatch]);



    const openLoader = useCallback(() => {
        actions.openLoader(dispatch);
    }, [dispatch]);

    const closeLoader = useCallback(() => {
        actions.closeLoader(dispatch);
    }, [dispatch]);

    const handleModalClose = () => {
        setOpenModal(false);
    };
    const handleClickOpen = (plan_id) => {
        sessionStorage.setItem('plan_id', plan_id);
        setOpen(true)
        openCloseAlert(true, (pageType == Languages.TopupESIM || sessionStorage.getItem('bundle') == Languages.TopUp) ? Languages.TopupAlert : Languages.PurchaseAlert, Languages.PlanDetails);
    };

    const handleClose = () => {
        openCloseAlert(false, "", "");
    };

    const createClientSecretKey = async () => {
        openLoader();
        const planId = sessionStorage.getItem('plan_id');
        var data = {};
        var url = '';
        if (pageType == Languages.TopupESIM || sessionStorage.getItem('bundle') == Languages.TopUp) {
            data = {
                activation_id: activation_id,
                plan_id: planId,
                plan_type: 2,
                platform: Languages.Platform
            };
            url = Constants.ClientSecretKey;
        } else {
            if (pageType == Languages.Local) {
                var telsim = sessionStorage.getItem('telsim');
                if (telsim == 'true') {
                    data = {
                        plan_id: planId
                    };
                    url = Constants.AddNewSIMTelsimPayment;
                } else {
                    data = {
                        plan_id: planId,
                        platform: Languages.Platform
                    };
                    url = Constants.AddNewSIMClientSecret;
                }
            } else {
                data = {
                    plan_id: planId,
                    platform: Languages.Platform
                };
                url = Constants.AddNewSIMClientSecret;
            }
        }

        let headers = await getApiHeader();
        const response = await UserAPI.postData(data, headers, url);

        if (response !== undefined) {
            if (response.status === 200) {
                confirmCardPayment(response.data);
            } else {
                closeLoader();
                showMsg(response.message, Constants.SnackBarType.Error); // Use showMsg here
            }
        } else {
            closeLoader();
            showMsg(Languages.ServerError, Constants.SnackBarType.Error); // Use showMsg here as well
        }
    }

    const toTopUp = (data, type, url) => {

        console.log('toTopUp data ----------->', data);
        console.log('toTopUp type ----------->', type);
        console.log('toTopUp type ------------>', url)

        onContinue(data, type, url)
    }


    const confirmCardPayment = async (data) => {
        try {
            var clientSecret = data.clientSecret;
            var session = data.session;
            var cardId = data.cardId;

            if (!stripe) {
                closeLoader();
                // Stripe.js has not yet loaded.
                return;
            }
            openLoader();
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: cardId,
            });

            if (result.error) {
                // Payment failed, display error to the user
                closeLoader();
                console.log(result.error.message);
                showMsg(result.error.message, Constants.SnackBarType.Error)
            } else if (result.paymentIntent.status === 'succeeded') {
                // Payment successful
                console.log('Payment successful!');
                var data = data = {
                    session: session
                };
                if (pageType == Languages.TopupESIM || sessionStorage.getItem('bundle') == Languages.TopUp) {
                    toTopUp(data, pageType, Constants.TopUp);
                } else {
                    if (pageType == Languages.Local) {
                        var newTelsim = sessionStorage.getItem('telsim');
                        if (newTelsim == 'true') {
                            toTopUp(data, pageType, Constants.AddNewSIMTelsimActivation);
                        } else {
                            toTopUp(data, pageType, Constants.AddNewSIMActivation);
                        }

                    } else {
                        toTopUp(data, pageType, Constants.AddNewSIMActivation);
                    }
                }
            }
        } catch (e) {
            console.log(e);
            closeLoader();
            //setIsLoading(false)
        }
    }

    return (
        <div className='col-lg-3 col-md-4'>
            <div id='box' className='planBox pBox'>
                <br />
                <h3>{planData.plan_name}</h3>
                <br />

                {pageType === Languages.TopupESIM ? ( 
                   <p className="planAmount">
                   {planData?.plan_offer_amount > 0 ? (
                       <>
                           <span style={{ textDecoration: "line-through", marginRight: "8px", color: "gray" }}>
                               ${planData?.plan_amount}
                           </span>
                           ${planData.plan_offer_amount}
                       </>
                   ) : (
                       <>${planData?.plan_amount}</>
                   )}
               </p>
                    ) : (

                    <p className="planAmount">${planData.plan_amount}

                        {/* {(planData.plan_selling_amount != planData.plan_amount && (
                            <span>${planData.plan_amount}</span>)
                        )} */}


                    </p>
                )
                }

                {/* {planData.offer_title ? (
                    <p className="planAmountCondition">{planData.offer_title}</p>
                ) :
                    <p className="hiddenDetails"></p>
                } */}
                {/* <p className="hiddenDetails"></p> - this for align height if any plan have extra line and add this in else case for all other cards*/}

                {/* <p className="planAmountCondition">*1<sup>st</sup> 6 months lanuch offer</p> */}
                <br />
                <p className="plandDetail"><b><i className="fa fa-signal"></i> {Languages.Data} <span>{planData.plan_data + ' ' + Languages.GB}</span></b></p>
                <br />
                <p className="plandDetail"><b><i className="fa fa-calendar"></i> {Languages.Validity} <span>{planData.plan_validity + ' ' + Languages.Days}</span></b></p>
                <br />
                <p className="additoinalDetailHead"><b>Additional Informations:</b></p>

                {planData.plan_details.map((detail, index) => (
                    <p className="additionalDetail" key={index}>
                        <i className="fa fa-dot-circle-o" style={{ color: '#FF4300', marginRight: '8px' }}></i> {detail.specification_name} : {detail.specification_value}
                    </p>
                ))}

                <br />
                <button
                    type="button"
                    className="value-btn-1 valueBtn"
                    onClick={() => handleClickOpen(planData.plan_id)}
                >
                    {Languages.BuyNow}
                </button>            </div>

            {alertPage == Languages.PlanDetails && (<Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                {/* <DialogTitle>{"Use Google's location service?"}</DialogTitle> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {alertMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}  style={{color:"white", backgroundColor:"#FF4300"}}>No</Button>
                    <Button onClick={() => {
                        handleClose();
                        // confirmCardPaymentTest()
                        createClientSecretKey();
                    }} style={{color:"white", backgroundColor:"#FF4300"}}>Yes</Button>
                </DialogActions>
            </Dialog>)}
            <BootstrapDialog
                onClose={handleModalClose}
                aria-labelledby="customized-dialog-title"
                open={openModal}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleModalClose}>
                    {Languages.SupportedNetWorks}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    {/* <div className='row'>
                        {(PlanType != Languages.Country && PlanType != "") ? setPopUpCountryList(supportedCNetwork) : setPopUpCountryList(supportedCountry)}
                    </div> */}
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleModalClose}>
                        Close
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}
export default PlanItem;